import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { WifiOff, Wifi } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

export function OfflineBanner() {
  const { isOnline, wasOffline } = useOnlineStatus();

  if (isOnline && !wasOffline) return null;

  if (!isOnline) {
    return (
      <Alert className="rounded-none border-x-0 border-t-0 bg-warning/10 text-warning-foreground">
        <WifiOff className="h-4 w-4" />
        <AlertTitle>You're currently offline</AlertTitle>
        <AlertDescription>
          You can still browse previously loaded product pages and wishlists. Your actions will sync when you reconnect.
        </AlertDescription>
      </Alert>
    );
  }

  if (wasOffline) {
    return (
      <Alert className="rounded-none border-x-0 border-t-0 bg-success/10 text-success-foreground animate-in slide-in-from-top">
        <Wifi className="h-4 w-4" />
        <AlertTitle>You're back online!</AlertTitle>
        <AlertDescription>
          Your shopping session has been restored and your cart is updated. All pending actions will now sync.
        </AlertDescription>
      </Alert>
    );
  }

  return null;
}
